import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiShield, FiHeart, FiUsers, FiStar } = FiIcons;

const About = () => {
  const values = [
    { icon: FiHeart, text: "Respect all members" },
    { icon: FiUsers, text: "Be helpful to others" },
    { icon: FiStar, text: "Be active, but real life comes first" },
    { icon: FiShield, text: "No toxic behavior or drama" }
  ];

  return (
    <section id="about" className="py-20 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-emerald-900/50 via-blue-900/50 to-purple-900/50"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="text-5xl md:text-6xl font-bold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-blue-400" style={{ fontFamily: 'fantasy, serif' }}>
            About Crimson Guild
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <div className="bg-gradient-to-br from-red-900/80 to-purple-900/80 p-8 rounded-2xl shadow-2xl border border-red-500/30 backdrop-blur-sm">
              <h3 className="text-3xl font-bold text-yellow-400 mb-6">🏰 Welcome to Crimson!</h3>
              <p className="text-white text-lg leading-relaxed mb-6">
                We are a united guild of adventurers who strive for glory, camaraderie, and fun! 
                Whether you're new or experienced, we welcome everyone who wants to grow and contribute.
              </p>
              <div className="bg-gradient-to-r from-yellow-500/20 to-red-500/20 p-4 rounded-lg border border-yellow-500/30">
                <p className="text-yellow-300 font-semibold">
                  <strong>Guild Leader:</strong> Juny
                </p>
                <p className="text-emerald-300 font-semibold mt-2">
                  <strong>Vice Leaders:</strong> Junn, Button, Merik, Shrezy, Elesya
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <div className="bg-gradient-to-br from-blue-900/80 to-emerald-900/80 p-8 rounded-2xl shadow-2xl border border-blue-500/30 backdrop-blur-sm">
              <h3 className="text-3xl font-bold text-emerald-400 mb-6">🌟 Guild Values</h3>
              <div className="space-y-4">
                {values.map((value, index) => (
                  <motion.div
                    key={index}
                    className="flex items-center space-x-4 p-4 bg-gradient-to-r from-emerald-500/20 to-blue-500/20 rounded-lg border border-emerald-500/30"
                    initial={{ opacity: 0, x: 20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.6, delay: index * 0.1 }}
                    viewport={{ once: true }}
                    whileHover={{ scale: 1.02, x: 10 }}
                  >
                    <div className="w-10 h-10 bg-gradient-to-br from-emerald-500 to-blue-500 rounded-full flex items-center justify-center shadow-lg">
                      <SafeIcon icon={value.icon} className="text-white text-lg" />
                    </div>
                    <span className="text-white font-medium">{value.text}</span>
                  </motion.div>
                ))}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;